/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tools_Legajox_Org_Chart_ErrorInputs */

const es_tools_legajox_org_chart_error = /** @type {(inputs: Tools_Legajox_Org_Chart_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error al consultar organigrama de Legajox`)
};

const en_tools_legajox_org_chart_error = /** @type {(inputs: Tools_Legajox_Org_Chart_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error querying Legajox org chart`)
};

/**
* | output |
* | --- |
* | "Error querying Legajox org chart" |
*
* @param {Tools_Legajox_Org_Chart_ErrorInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const tools_legajox_org_chart_error = /** @type {((inputs?: Tools_Legajox_Org_Chart_ErrorInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tools_Legajox_Org_Chart_ErrorInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tools_legajox_org_chart_error(inputs)
	return en_tools_legajox_org_chart_error(inputs)
});
export { tools_legajox_org_chart_error as "tools.legajox.org_chart_error" }